import supportedLocales from "@/settings/supported-locales";

export function getSupportedLocales() {
  return supportedLocales.map(({ code, label }) => ({
    code,
    name: label
  }));
}

export function supportedLocalesInclude(code) {
  return supportedLocales.some(locale => locale.code === code) != null;
}
